import { useMutation, useQueryClient } from '@tanstack/react-query';
import Api from '../api/Api';
import { MUTATION_KEYS, QUERY_KEYS } from './queryKeys';

export default function useClearCartMutation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: [MUTATION_KEYS.cart.clearCart],
    mutationFn: async () => {
      return await Api.shopping.ClearCart();
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: [QUERY_KEYS.cart.getShoppingCart],
      });
    },
  });
}
